export class Task {
  public id: number;
  public status: string;
  public remark: string;
  public creationUser: string;
  public creationDateTime: Date;
  public type: string;
  public contractId?: number;
  public fileInfo?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/task.model.ts